import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { LISTVIEW_TITLE_TAGS } from '../../constants';
import findUrl from '../../utils/findUrl';
import getRoute from '../../utils/getRoute';
import config from '../../../src/client/config';

const { urlRoot } = config;

const Meta = ({
  data = [],
  page,
  slug,
  suburb,
  state,
  postcode,
  searchKeyword,
  total,
  reviewAggregates,
}) => {
  const { pathname } = useLocation();
  const route = getRoute(pathname);
  const isFind = route === 'find';
  const { count: reviewCount } = reviewAggregates || {};
  const titleTag = isFind
    ? LISTVIEW_TITLE_TAGS({
        keyword: searchKeyword,
        suburb,
        state,
        postcode,
      })
    : `${searchKeyword || ''} in ${suburb || ''} ${state || ''} | Localsearch`;

  let description = `The best ${searchKeyword} in ${suburb} ${state}! Read reviews, find payment options, send enquiries and so much more on Localsearch.`;
  if (total) {
    description = `${total} of the best ${searchKeyword} in ${suburb} ${state}! Read reviews, find payment options, send enquiries and so much more on Localsearch.`;
  }

  if (reviewCount) {
    description = `${total} of the best ${searchKeyword} in ${suburb} ${state}! Read the ${reviewCount}+ reviews, find payment options, send enquiries and so much more on Localsearch.`;
  }

  return (
    <Helmet>
      <title>{titleTag}</title>

      {isFind && page >= 1 ? (
        <link
          rel="prev"
          href={findUrl({
            keyword: searchKeyword,
            suburb_url: slug,
            suburb,
            state,
            postcode,
            page: page - 1,
          })}
        />
      ) : (
        ''
      )}

      {isFind && total > data.length ? (
        <link
          rel="next"
          href={findUrl({
            keyword: searchKeyword,
            suburb_url: slug,
            suburb,
            state,
            postcode,
            page: page + 1,
          })}
        />
      ) : (
        ''
      )}

      <meta name="description" content={description} />
      <meta
        property="og:title"
        content={`${searchKeyword} | ${suburb} ${state} | Localsearch`}
      />
      <meta property="og:type" content="company" />
      <meta
        property="og:description"
        content={`Your Best Localsearch for ${searchKeyword} in ${suburb}, ${state} - Localsearch. For the most complete local list of ${searchKeyword} in ${suburb}, ${state}, including Full Contact Details, Business Descriptions, Mapping and Directions, as well as service and product information, always choose Localsearch!`}
      />
      {isFind ? (
        <link
          rel="canonical"
          href={`${urlRoot}${findUrl({
            keyword: searchKeyword,
            suburb_url: slug,
            suburb,
            state,
            postcode,
          })}`}
        />
      ) : (
        <meta name="robots" content="noindex" />
      )}
      <meta name="robots" content="noimageindex" />
    </Helmet>
  );
};
export default Meta;
